import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['tab', 'content']

  connect() {
    if (this.firstActiveStep){
      this.revealContentIndex(parseInt(this.firstActiveStep), true);
    } else {
      this.revealContentIndex(0, true);
    }
  }

  get firstActiveStep() {
    return this.element.getAttribute('data-first-active-step');
  }

  get formController() {
    return this.element.querySelector('form').form;
  }

  get currentTab() {
    return this.tabTargets[this.currentContentIndex];
  }

  get currentContent() {
    return this.contentTargets.find(content => !Array.from(content.classList).includes('hidden'));
  }

  get currentContentIndex() {
    return this.contentTargets.indexOf(this.currentContent);
  }

  handleSwitch(oldIndex, newIndex) {
    if (oldIndex < newIndex) {
      if (newIndex - oldIndex == 1) {
        const tab = this.tabTargets[oldIndex];

        if (tab.hasAttribute('data-attributes-validate')) {
          const content = this.contentTargets[oldIndex];
          const isValid = this.validateTabContent(content);

          if (tab.hasAttribute('data-attributes-state')) {
            tab.tab.setValid(isValid);
          }

          if (isValid) {
            this.revealContentIndex(newIndex);
          }
        } else {
          this.revealContentIndex(newIndex);
        }
      } else {
        const tabs = this.tabTargets.slice(oldIndex, newIndex);

        const allValid = tabs.map((tab, index) => {
          const noErrors = !this.tabTargets.some(_tab => _tab.tab.currentState == 'invalid');
          const checkValidation = (index == oldIndex) || noErrors;

          if (checkValidation) {
            if (tab.hasAttribute('data-attributes-validate')) {
              const tabIndex = this.tabTargets.indexOf(tab);
              const content = this.contentTargets[tabIndex];
              const isValid = this.validateTabContent(content);

              if (tab.hasAttribute('data-attributes-state')) {
                tab.tab.setValid(isValid);
              }

              return isValid;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }).every(res => res === true);

        if (allValid) {
          this.revealContentIndex(newIndex);
        } else {
          // get the first tab that is in the error state to make sure it's visible
          const tab = this.tabTargets.find(tab => tab.tab.currentState == 'invalid');
          const revealIndex = this.tabTargets.indexOf(tab);

          if (this.currentContentIndex != revealIndex) {
            this.revealContentIndex(revealIndex);
            tab.tab.setValid(false);
          }
        }
      }
    } else {
      this.revealContentIndex(newIndex);
    }
  }

  navigate(event) {
    event.preventDefault();

    const _newIndex = this.tabTargets.indexOf(event.currentTarget);
    const _oldIndex = this.currentContentIndex;

    if (_newIndex === _oldIndex) return;

    this.handleSwitch(_oldIndex, _newIndex);
  }

  // Special Navigate where we will delcare the index we want to navigate to via the 
  // data-tabs-nagviate-to-index-value='X'
  navigateTo(event) {
    event.preventDefault();
    const _newIndex = event.target.getAttribute('data-tabs-nagviate-to-index-value');
    if (_newIndex) {
      this.handleSwitch(this.currentContentIndex, parseInt(_newIndex));
    }
  }

  advance(event) {
    event.preventDefault();

    const _oldIndex = this.currentContentIndex;
    const _newIndex = this.currentContentIndex + 1;

    if (_newIndex > this.contentTargets.length) {
      return;
    }

    this.handleSwitch(_oldIndex, _newIndex);
  }

  back(event) {
    event.preventDefault();

    if ((this.currentContentIndex - 1) <= 0) {
      this.handleSwitch(this.currentContentIndex, this.currentContentIndex - 1);
    }
  }

  revealContentIndex(index, fromConnect=false) {
    this.contentTargets.forEach(content => content.classList.add('hidden'));
    this.contentTargets[index].classList.remove('hidden');

    if (!fromConnect) {
      this.tabTargets.forEach((tab, _index) => {
        if (tab.hasAttribute('data-attributes-state')) {
          tab.tab.setActive(false);

          if (index === _index) {
             tab.tab.setActive(true);
          }
        }
      });
    }

    if (this.currentTab.hasAttribute('data-attributes-first-input-focus')) {
      this.focusFirstInput();
    }

    if (this.currentTab.hasAttribute('data-attributes-scroll-to-view')) {
      this.currentTab.scrollIntoView(false, {behavior: 'smooth'});
    }
  }

  focusFirstInput() {
    const _input = this.currentContent.querySelector('input:not([type="hidden"],[type="submit"]), select, textarea');
    _input?.focus();
  }

  validateTabContent(content) {
    const fieldsets = content.querySelectorAll('fieldset');
    const results = Array.from(fieldsets).reverse().map(fieldset => this.formController.fieldsetValid(fieldset));
    const valid = results.every(x => x.valid === true);

    if (!valid) {
      this.formController.pushToast('error', 'Error', 'There are ' + results.map(x=>x.errorCount).reduce(((a, b) => a+b), 0) + ' errors that require fixing');
    }

    return valid;
  }
}
